<template lang="pug">
  v-row.mx-0.pt-2(wrap)
    v-col(v-if="!$get(posts, `length`)")
      v-sheet
        illustration-state(
          :illustration="illustration"
          body="Aucune publication")
    utility-virtual-scroll(
      v-else
      :items="posts")
      template(#default="{ item: post, props }")
        v-col(
          :cols="12"
          v-bind="props")
          v-card(outlined)
            v-list(two-lines)
              v-list-item
                slot(name="avatar" :post="post")
                  v-list-item-avatar(
                    @click="onGoToAuthor(post)"
                    color="primary")
                v-list-item-content
                  v-list-item-title(@click="onGoToAuthor(post)") {{ getAuthor(post) }}
                  v-list-item-subtitle {{ getTimeAgo(post) }}
                v-list-item-action(v-if="onClickMore(post)")
                  v-btn(
                    @click="onClickMore(post)()"
                    icon)
                    v-icon {{ mdiDotsVertical }}
            v-img(
              v-if="getImage(post)"
              contain
              :src="$get(getImage(post), `src`)"
              :lazy-src="$get(getImage(post), `srcLazy`)")
            v-card-text {{ getContent(post) }}
            v-row.px-4
              v-btn(
                small
                text) {{ $pluralize({ count: getLikesCount(post), word: 'like' }) }}
              v-spacer
              v-btn(
                @click="onGoToComments(post)"
                small
                text) {{ $pluralize({ count: getCommentsCount(post), word: 'commentaire'}) }}
            v-card-actions.mt-4
              v-row.align-center(dense)
                v-btn(
                  :loading="loadingLikeButton.includes(post.id)"
                  @click="onLikeOrUnlike(post)"
                  :color="isLiked(post) ? 'primary' : undefined"
                  rounded
                  depressed)
                  v-icon(left) {{ mdiHeart}}
                  | J'aime
                v-spacer
                v-btn(
                  @click="onGoToCommentsToComment(post)"
                  rounded
                  depressed)
                  v-icon(left) {{ mdiComment }}
                  | Commenter
</template>

<script>
import { reactive, toRefs, computed } from '@vue/composition-api'
import { mdiDotsVertical, mdiHeart, mdiShare, mdiComment } from '@mdi/js'
import Now from '@iez/features/now/'
import UtilityVirtualScroll from './utility-virtual-scroll/'
import IllustrationState from '@iez/components/illustration-state/'
import NoData from '@iez/illustrations/NoData'

export default {
  components: {
    UtilityVirtualScroll,
    IllustrationState
  },

  props: {
    posts: Array,
    getId: Function,
    getAuthor: Function,
    getContent: Function,
    getImage: Function,
    getCreatedAt: Function,
    getLikesCount: Function,
    getCommentsCount: Function,
    isLiked: Function,
    onLike: Function,
    onUnlike: Function,
    onClickMore: Function,
    onGoToAuthor: Function,
    onGoToComments: Function,
    onGoToCommentsToComment: Function
  },

  setup (props) {
    const state = reactive({
      loadingLikeButton: []
    })

    const onLikeOrUnlike = async post => {
      state.loadingLikeButton.push(post.id)
      if (props.isLiked(post)) {
        await props.onUnlike(post)
      } else {
        await props.onLike(post)
      }
      state.loadingLikeButton.splice(
        state.loadingLikeButton.indexOf(post.id),
        1
      )
    }

    const getTimeAgo = post => {
      const createdAt = props.getCreatedAt(post)
      return Now.getTimeAgo({ datetime: createdAt })
    }

    return {
      mdiDotsVertical,
      mdiShare,
      mdiComment,
      mdiHeart,
      onLikeOrUnlike,
      getTimeAgo,
      ...toRefs(state),
      illustration: NoData
    }
  }
}
</script>
